<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                            <router-link :to="{'name': 'CadastrarAlertas'}" class="button big block-mobile float-right hidden-lg hidden-md">
                                <i class="material-icons">add</i>
                                Cadastrar alerta
                            </router-link>
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">

                        <!-- Dashboard Box -->
                        <div class="col-lg-12 margin-bottom-20 hidden-xl">
                            <router-link :to="{'name': 'CadastrarAlertas'}" class="button big block-mobile">
                                <i class="material-icons">add</i>
                                Cadastrar alerta
                            </router-link>
                        </div>                          
                        <div class="col-xl-12">

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 280px; width: 280px;">
                                            Tipo do alerta
                                        </th>
                                        <th style="min-width: 150px; width: 150px;">
                                            Condição
                                        </th>                                         
                                        <th style="min-width: 140px; width: 140px;">
                                            Cadastro
                                        </th>
                                        <th style="min-width: 50px; width: 50px;">
                                            Ações
                                        </th>                                                                     
                                    </thead>
                                    <tbody>   

                                        <tr v-for="item in data.itens">
                                            <td data-label="ID">
                                                <router-link :to="{'name': 'EditarAlertas', 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.id}}
                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': 'EditarAlertas', 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    <u>{{item.nome}}</u>
                                                </router-link>
                                            </td>                                         
                                            <td data-label="Tipo do alerta">
                                                <i class="material-icons">assessment</i>
                                                <router-link :to="{'name': 'EditarAlertas', 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.tipo == 'estoque-nivel' ? 'Se o nível (%) de combustível no(s) tanque(s)' : ''}}
                                                </router-link>
                                            </td>
                                            <td data-label="Condição">    
                                                {{item.condicao == '<=' ? 'For igual ou menor que' : ''}} {{item.valor}}%
                                            </td>                                            
                                            <td data-label="Cadastro">
                                                <router-link :to="{'name': 'EditarAlertas', 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.datahora | formatDate}}
                                                </router-link>
                                            </td>   
                                            <td data-label="Ações">
                                                <router-link :to="{'name': 'EditarAlertas', 'query': {'c': item.cod}}" class="dashboard-status-button gray">Editar</router-link>
                                                <a class="dashboard-status-button color-red" v-on:click="del(item.cod)">Apagar</a>                                                                                      
                                            </td>                                                                                                                                       
                                        </tr>
        

                                    </tbody>
                                </table>
                            
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Usuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1
            }              
        }
    },
    methods: {
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.data.pesquisa != self.form.pesquisa) {
                    self.form.page  = 1;
                }

                axios.get("api/alertas.php", {params: self.form, db: "alertas"})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data   = response.data.result; 
                    self.loaded = true;
                    loading.hide();
                    self.$root.scrollTop();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/alertas.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }        
    },
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.get();
            });
        } else {
            self.get();
        }          
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Alertas.vue